import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  cursor: default;
`;

export const FormActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  column-gap: 16px;
`;
